/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DataTable from "Tables/DataTable";
import { useEffect, useState } from "react";

import { getData } from "Utils/server";
import { getAuthorizationHeader, getUserData } from "Utils/helpers";

import { useSoftUIController } from "context";

function Sessions() {
  const [controller, dispatch] = useSoftUIController();
  const { platform } = controller;
  const [loading, setLoading] = useState(true);

  const [dataTableData, setDataTableData] = useState({
    columns: [
      { Header: "agent", accessor: "user_agent", width: "100px", Cell: wrapWordCell },
      { Header: "ip address", accessor: "ip_address", width: "100px" },
      {
        Header: "Date",
        accessor: "created_at_utc",
        width: "100px",
        Cell: formatDateStringUTCtoLocale,
      },
      { Header: "activity", accessor: "activity", width: "100px" },

      //   { Header: "roles", accessor: "roles", Cell: makeList, width: "120px" },
      //   { Header: "status", accessor: "status", width: "120px", Cell: makeStatusCell },
    ],

    rows: [],
  });

  function wrapWordCell({ value, ...rest }) {
    let headerName = rest.column.id;
    let userAgentString = value;

    let os = "";
    let browser = "";
    let mobile = false;

    if (userAgentString.indexOf("obile") > -1) {
      mobile = true;
    }

    if (userAgentString.indexOf("indows") > -1) {
      os = "Windows";
    } else if (userAgentString.indexOf("ndroid") > -1) {
      os = "Android";
    } else if (userAgentString.indexOf("inux") > -1) {
      os = "Linux";
    } else if (userAgentString.indexOf("acintosh") > -1) {
      os = "Mac OS";
    }

    // Detect Chrome
    let chromeAgent = userAgentString.indexOf("Chrome") > -1;

    // Detect Internet Explorer
    let IExplorerAgent =
      userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;

    // Detect Firefox
    let firefoxAgent = userAgentString.indexOf("Firefox") > -1;

    // Detect Safari
    let safariAgent = userAgentString.indexOf("Safari") > -1;

    // Discard Safari since it also matches Chrome
    if (chromeAgent && safariAgent) safariAgent = false;

    // Detect Opera
    let operaAgent = userAgentString.indexOf("OP") > -1;

    // Discard Chrome since it also matches Opera
    if (chromeAgent && operaAgent) chromeAgent = false;

    browser = chromeAgent
      ? "Chrome"
      : operaAgent
      ? "Opera"
      : safariAgent
      ? "Safari"
      : firefoxAgent
      ? "Firefox"
      : IExplorerAgent
      ? "Edge"
      : "Unknown Browser";

    return (
      <div className={headerName + "-cell"}>
        <Icon sx={{ marginRight: "10px", fontSize: "1.25rem !important", color: "#a3abbb" }}>
          {mobile ? "smartphone_icon" : "desktop_windows_icon"}
        </Icon>{" "}
        {"  " + browser + " on " + os}
      </div>
    );
  }

  function formatDateStringUTCtoLocale({ value, ...rest }) {
    if (!value) return "-";
    let date = new Date(value);
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
    let hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
    let minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    let dateformatted = day + "/" + month + "/" + date.getFullYear() + " " + hours + ":" + minutes;
    let timezone = (date.getTimezoneOffset() * -1) / 60;
    timezone = timezone > 0 ? "+" + timezone : timezone;
    return dateformatted;
  }

  
  async function initData() {
    const userData = getUserData();
    let userId = userData.id;

    let getLogsEndpoint = `/api/v1/users/${userId}/activity`;
    setLoading(true);
    let response = await getData(getLogsEndpoint, { Authorization: getAuthorizationHeader() });
    if (response != null) {
    }

    let data = { ...dataTableData };
    data.rows = response && response.data ? response.data : data.rows;

    //console.log("Init Data");
    setDataTableData(data);
    setLoading(false);
  }

  useEffect(() => {
    initData();
  }, []);

  return (
    <Card id="sessions">
      <SoftBox p={3} lineHeight={1}>
        <SoftBox mb={1}>
          <SoftTypography variant="h5">Login Sessions</SoftTypography>
        </SoftBox>
        <SoftTypography variant="button" color="text" fontWeight="regular">
          This is a list of devices that have logged into your account.
        </SoftTypography>
      </SoftBox>
      {/* <SoftBox pb={3} px={3} sx={{ overflow: "auto" }}>
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={{ xs: "max-content", sm: "100%" }}
        >
          <SoftBox display="flex" alignItems="center">
            <SoftBox textAlign="center" color="text" px={{ xs: 0, md: 1.5 }} opacity={0.6}>
              <Icon fontSize="default">desktop_windows</Icon>
            </SoftBox>
            <SoftBox height="100%" ml={2} lineHeight={1.4} mr={2}>
              <SoftTypography display="block" variant="button" fontWeight="regular" color="text">
                Bucharest 68.133.163.201
              </SoftTypography>
              <SoftTypography variant="caption" color="text">
                Your current session
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox display="flex" alignItems="center">
            <SoftBadge
              variant="contained"
              size="xs"
              badgeContent="active"
              color="success"
              container
            />
            <SoftBox mx={2} lineHeight={1}>
              <SoftTypography variant="button" color="secondary" fontWeight="regular">
                EU
              </SoftTypography>
            </SoftBox>
            <SoftTypography
              component="a"
              href="#"
              variant="button"
              color="info"
              fontWeight="regular"
              sx={actionButtonStyles}
            >
              See more&nbsp;
              <Icon sx={{ fontWeight: "bold", verticalAlign: "middle" }}>arrow_forward</Icon>
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <Divider />
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={{ xs: "max-content", sm: "100%" }}
        >
          <SoftBox display="flex" alignItems="center" mr={2}>
            <SoftBox textAlign="center" color="text" px={{ xs: 0, md: 1.5 }} opacity={0.6}>
              <Icon fontSize="default">desktop_windows</Icon>
            </SoftBox>
            <SoftBox ml={2}>
              <SoftTypography display="block" variant="body2" fontWeight="regular" color="text">
                Chrome on macOS
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox display="flex" alignItems="center">
            <SoftBox mx={2} lineHeight={1}>
              <SoftTypography variant="button" color="secondary" fontWeight="regular">
                US
              </SoftTypography>
            </SoftBox>
            <SoftTypography
              component="a"
              href="#"
              variant="button"
              color="info"
              fontWeight="regular"
              sx={actionButtonStyles}
            >
              See more&nbsp;
              <Icon sx={{ fontWeight: "bold", verticalAlign: "middle" }}>arrow_forward</Icon>
            </SoftTypography>
          </SoftBox>
        </SoftBox>
        <Divider />
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width={{ xs: "max-content", sm: "100%" }}
        >
          <SoftBox display="flex" alignItems="center" mr={2}>
            <SoftBox textAlign="center" color="text" px={{ xs: 0, md: 1.5 }} opacity={0.6}>
              <Icon fontSize="default">phone_iphone</Icon>
            </SoftBox>
            <SoftBox ml={2}>
              <SoftTypography display="block" variant="body2" fontWeight="regular" color="text">
                Safari on iPhone
              </SoftTypography>
            </SoftBox>
          </SoftBox>
          <SoftBox display="flex" alignItems="center">
            <SoftBox mx={2} lineHeight={1}>
              <SoftTypography variant="button" color="secondary" fontWeight="regular">
                US
              </SoftTypography>
            </SoftBox>
            <SoftTypography
              component="a"
              href="#"
              variant="button"
              color="info"
              fontWeight="regular"
              sx={actionButtonStyles}
            >
              See more&nbsp;
              <Icon sx={{ fontWeight: "bold", verticalAlign: "middle" }}>arrow_forward</Icon>
            </SoftTypography>
          </SoftBox>
        </SoftBox>
      </SoftBox> */}
      <DataTable
        table={dataTableData}
        entriesPerPage={{
          defaultValue: 10,
          entries: [5, 7, 10, 15, 20, 25],
        }}
        hiddenColumns={["activity"]}
        canSearch
        openBackDrop={loading}
      />
    </Card>
  );
}

export default Sessions;
